import Base from "./Base"

const config = {
  ...Base,
  httpBaseUri: "https://dev-api.operandiodev.com",
  httpServiceBaseUri: "https://dev-api.operandiodev.com/graphql",
  wsServiceBaseUri: "wss://dev-api.operandiodev.com/graphql",

  clientKiosk: false,

  showConfigInConsole: true,
  showConfigInTitle: true,
  configTitle: "[DEV]",

  dataClient: {
    ...Base.dataClient,
    connectToDevTools: true
  },

  theme: {
    ...Base.theme,

    logoContainer: "images-dev"
  },

  uploader: {
    ...Base.uploader,

    imageViewerBaseUri: "https://d2y50qvg2q46in.cloudfront.net",
    imageViewerBucketName: "dev-operandio-content-ap-southeast-2",

    videoViewerBaseUri: "https://dev-video.operandiodev.com",
    videoViewerBucketName: "dev-operandio-content-ap-southeast-2",

    scormUploadBucketName: "dev-operandio-scorm-quarantine",
    scormViewerBaseUri: "https://dev-scorm.operandiodev.com"
  },

  services: {
    ...Base.services,
    export: {
      ...Base.services.export,
      jobUrl: "https://lxknk3pfv9.execute-api.ap-southeast-2.amazonaws.com/prod/job/", // DEV account
      auditUrl: "https://lxknk3pfv9.execute-api.ap-southeast-2.amazonaws.com/prod/auditscores/" // DEV account
    }
  },

  errors: {
    ...Base.errors,

    showDetail: true,
    showGraphQLErrorNotification: true
  }
}

config.dataClient.throwIfNoOperationName = true

export default config
